import Stack from '@mui/material/Stack'

import TopCoinsBanner from '@/components/top-coins/banner'
import TopCoinsList from '@/components/top-coins/list'

const Container = () => {
  return (
    <Stack className="sm:my-10 my-6 gap-[12px] lg:gap-[30px]">
      <TopCoinsBanner />
      <TopCoinsList />
    </Stack>
  )
}

export default Container
